import { Libraries } from '@react-google-maps/api'
import { useState } from 'react'
import { PRIMARY_COLOR } from '../../constants'
import { useGoogleMaps } from '../../hooks/useGoogleMaps'
import { SelectedGoogleLocation } from '../../redux-toolkits/shared/shared.type'
import Icon from '../icon'
import { LoadingOval } from '../spinner/Spinner'
import { SearchInput } from './searchInput'

const libraries: Libraries = ['places']

const AddressInput = ({
  onSelect,
  value,
  bgColor = 'bg-gray-bg',
  className,
}: {
  onSelect?: (address: SelectedGoogleLocation) => void
  value?: string
  bgColor?: string
  className?: string
}) => {
  const [selectedPlaceId, setSelectedPlaceID] = useState('')

  const {
    isLoaded,
    loading,
    status,
    data,
    handleSelect,
    setAutoCompleteValue,
  } = useGoogleMaps()

  return !isLoaded ? (
    <div className="flex items-center justify-center">
      <LoadingOval loaderHeight="30" loaderWidth="30" color={PRIMARY_COLOR} />
    </div>
  ) : (
    <div
      className={`
        ${className}
        `}
    >
      <SearchInput
        searchFunction={(search) => {
          const placeData = {
            address: '',
            city: '',
            state: '',
            country: '',
            lat: '',
            lng: '',
            destinationGooglePlaceID: '',
          }

          if (onSelect) {
            setSelectedPlaceID('')
            onSelect(placeData)
          }

          setAutoCompleteValue(search)
        }}
        initialValue={''}
        className="!max-w-full"
      />

      {loading ? (
        <div className="flex items-center justify-center mt-6">
          <LoadingOval
            loaderHeight="30"
            loaderWidth="30"
            color={PRIMARY_COLOR}
          />
        </div>
      ) : (
        <div
          className={`${
            data.length > 0 ? 'h-[250px]' : 'h-0'
          } overflow-y-scroll transition-all duration-300
         w-full flex flex-col mt-6
         `}
        >
          {status === 'OK'
            ? data.map((place) => {
                return (
                  <button
                    type="button"
                    key={place.place_id}
                    className={`
                    flex gap-4 items-center p-3
                    border-b last:border-b-0
                    w-full text-left soft-shrink
                    ${
                      place.place_id === selectedPlaceId
                        ? 'bg-gray-100 !border border-black rounded-md'
                        : ''
                    }
                  `}
                    onClick={async () => {
                      await handleSelect(
                        place.description,
                        place.place_id,
                        true,
                        (locData) => {
                          if (onSelect) {
                            setSelectedPlaceID(place.place_id)
                            onSelect(locData!)
                          }
                        },
                      )
                    }}
                  >
                    <Icon id={'location'} width={16} height={16} />
                    <p className="flex-1">{place.description}</p>
                  </button>
                )
              })
            : []}
        </div>
      )}
    </div>
  )
}

export default AddressInput
